import { DemoAlert, EmailConfirmationAlert } from '@/components/commons/Alerts'

export default function Alerts({ siteData }: { siteData?: any }) {
  return (
    <>
      {siteData?.isDemonstration && <DemoAlert />}
      <EmailConfirmationAlert siteData={siteData} />
    </>
  )
}
